import React from 'react'
import Card from './commons/Card'
import LoanSummary from './commons/LoanSummary'
import RegistrationForm from './commons/RegistrationForm'
import Back from './commons/Back'

class Registration extends React.Component {

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  render() {
    return (
      <div className='row'>
        <div className='col-sm-6'>
          <Card className="save-progress-card">
            <br />
            <h3>Save your progress so far</h3>
            <p className='grey'>You have come so far already, and creating a login will allow you to save and continue.</p>
            <br />

            <RegistrationForm onRegistrationSubmit = { this.props.onRegistrationSubmit }
                              errors={ this.props.registrationErrors } />
          </Card>
          <br />
          <Back onGoBack={this.props.onGoBack} />
        </div>

        <div className='col-sm-6'>
          <LoanSummary loanApplication={this.props.loanApplication}/>
        </div>
      </div>
    )
  }
}

export default Registration
